<template>
  <a-modal
    title="Verify OTP - Authenticator App"
    :open="isMfaSetupModalVisible"
    :confirm-loading="confirmLoading"
    :mask-closable="false"
    @ok="handleOk"
    @cancel="() => emit('closeMfaSetupModal', true)"
    okText="Verify"
    cancelText="Close"
    class="otp-authentication-modal"
  >
    <div class="qr-code-wrapper">
      <p class="qr-code-instruction">Please scan this QR code using your Authenticator app.</p>
      <div class="qr-code-container">
        <img v-if="QRImage" :src="QRImage" alt="QR Code" class="qr-code-img" />
        <a-spin v-else />
      </div>
    </div>

    <div class="otp-instruction">
      <p>After scanning the QR code, enter the 6-digit OTP from your Authenticator app below.</p>
    </div>

    <otp-input
      @update-otp-value="updateOtpValue"
      @otp-enter-complete="handleOk"
      :disable-input="!QRImage"
    />
  </a-modal>
</template>

<script setup>
import AuthService from 'src/services/auth'
import { useAuthStore } from 'src/stores/auth'
import { onMounted, ref } from 'vue'
import { useToast } from 'vue-toastification'
import OtpInput from './OtpInput.vue'

const props = defineProps({
  isUserLoggingIn: Boolean,
  isMfaSetupModalVisible: Boolean
})

const emit = defineEmits(['closeMfaSetupModal'])

const otpValue = ref('')
const confirmLoading = ref(false)
const QRImage = ref(null)
const toast = useToast()
const authStore = useAuthStore()
const scanQRCodeMessage = 'Please scan this QR code from your authenticator app.'

const fetchQRCode = async () => {
  try {
    const [error, data] = await AuthService.getQRCode()
    const blob = new Blob([data], { type: 'image/png' })
    QRImage.value = URL.createObjectURL(blob)
  } catch (error) {
    console.error('Error fetching QR code:', error)
  }
}

onMounted(async () => {
  await fetchQRCode()
  toast.success(scanQRCodeMessage)
})

const updateOtpValue = (value) => {
  otpValue.value = value
}

const handleOk = async () => {
  confirmLoading.value = true
  const success = await authStore.setOtpMethod(
    { OTP: otpValue.value },
    'googleAuth',
    props.isUserLoggingIn
  )

  if (success) {
    emit('closeMfaSetupModal', false)
  }
  confirmLoading.value = false
}
</script>

<style scoped>
.qr-code-wrapper {
  text-align: center;
  margin-bottom: 20px;
}

.qr-code-instruction {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-code-img {
  width: 200px;
  height: 200px;
  display: block;
  margin: 0 auto;
}

.otp-instruction {
  text-align: center;
  margin-bottom: 20px;
}
</style>
